import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AddCustomImage } from 'services/addBox'
import { resetImage } from 'store/redux/image'
import { reset, toggleMoneyPool } from 'store/redux/moneyPoolBox'
import posthog from 'posthog-js'

export default function useSetCustomImage(statege: number | undefined) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { mutate, isLoading } = useMutation({
        mutationFn: (payload: { file: File; id: number }) => {
            return AddCustomImage(payload)
        },
        onSuccess: (res) => {
            dispatch(
                toggleMoneyPool({
                    moneyPool: res.results.id,
                    poolShip: res.results.poolship.id,
                })
            )
            if (statege === 1) {
                dispatch(reset())
                dispatch(resetImage())
                posthog.capture('fund_created', {
                    creation_path: 'custom_image',
                    fund_id: (res as any)?.results?.id,
                })
                navigate('/funds')
                toast.success('صندوق با موفقیت ساخته شد')
            } else {
                toast.success(
                    'صندوق شما با اطلاعات اولیه ساخته شد . اکنون سوابق مدیر را وارد کنید'
                )
                navigate('/add-box/manager-records')
            }
        },
        onError: () => {
            posthog.capture('fund_create_failed', {
                creation_path: 'custom_image',
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { CustomImageMutate: mutate, isLoadingImage: isLoading }
}
